import {gql} from 'apollo-angular';
import { ApiKey } from '../../shared/entities/apiKey/apiKey';

export const API_KEY_QUERY = gql`
query getApiKeyQuery(
  $id: UUID
)
{
  apiKey: getApiKey(
    id: $id
  )
  {
    id
    comment
  }
}
`;

export interface ApiKeyQueryResponse {
  apiKey: ApiKey;
}
